
export const chatSelectStatusOptions = [
  { value: 'Open', label: 'Open' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Closed', label: 'Closed' },
];
